'use client';

import { Pill, VisuallyHidden } from '@mantine/core';
import Image from 'next/image';
import type { ReactNode } from 'react';
import {
	HelpContent,
	HelpContentHeading,
} from '../../app/(client)/(authenticated)/reportProblem/questions/(premise)/problemType/HelpContent';
import overheadEquipmentBase from './overheadEquipmentBase.png';
import overheadEquipmentLabels from './overheadEquipmentLabels.svg';

export function OverheadEquipmentDetails(): ReactNode {
	return (
		<HelpContent>
			<HelpContentHeading>
				<h4>Overhead equipment, Distribution pole and equipment</h4>
				<Pill.Group>
					<Pill>Overhead equipment</Pill>
				</Pill.Group>
			</HelpContentHeading>
			<figure style={{ position: 'relative', display: 'inline-block', width: '100%', maxWidth: 1000 }}>
				<Image
					src={overheadEquipmentBase}
					alt="Picture of overhead equipment attached to a distribution pole"
					style={{ width: '100%', height: 'auto', display: 'block' }}
				/>
				<Image
					src={overheadEquipmentLabels}
					alt="Labels describing overhead equipment"
					style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: 'auto', display: 'block' }}
				/>
				<VisuallyHidden component="figcaption">
					Diagram of overhead equipment with components labeled.
				</VisuallyHidden>
			</figure>
		</HelpContent>
	);
}
